import closeModalIcon from "assets/img/icons/closeModal.svg";
import { FC, useEffect, useState } from "react";
import { FaCheck } from "react-icons/fa";
import Modal from "react-modal";
import Button from "app/components/button/button";
import { alphaLinks } from "app/config";
import { useTheme } from "app/shared";
import { useGetReferralCodeQuery } from "store/api/new.api";
import { useAccount } from "wagmi";
import styles from "./referral-modal.module.scss";

export interface PopupText {
  title: string;
  description: string;
  copyText: string;
  hasCopyLink: boolean;
  cta?: string;
  errorTitle: string;
  errorText: string;
  one?: string;
  two?: string;
  three?: string;
  four?: string;
}

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const ReferralModal: FC<ModalProps> = ({ isOpen, onClose }) => {
  const [isCopied, setIsCopied] = useState(false);
  let copyTimeout: ReturnType<typeof setTimeout>;
  const { theme } = useTheme();
  const [referralLink, setReferralLink] = useState<string>("");
  const { address } = useAccount();
  const account = address || "";
  const campaignId = "3ghuAYvu"; // Note: Referral codes are always from Claimr campaign

  const { data: ref, isLoading } = useGetReferralCodeQuery({
    account,
    campaignId,
  });

  useEffect(() => {
    if (ref?.ref_id) {
      const generatedLink = `${alphaLinks.BUILD_KARMA}?invite=${ref.ref_id}`;

      setReferralLink(generatedLink);
    }
  }, [ref]);

  useEffect(() => {
    return () => clearTimeout(copyTimeout);
  }, []);

  const handleCopyLink = () => {
    navigator.clipboard
      .writeText(referralLink)
      .then(() => {
        setIsCopied(true);
        copyTimeout = setTimeout(() => setIsCopied(false), 3000);
      })
      .catch((err) => console.error("Failed to copy link:", err));
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      className={`${styles.modalContent} ${
        theme === "dark" ? styles.darkTheme : ""
      }`}
      overlayClassName={styles.modalOverlay}
    >
      <button className={styles.closeButton} onClick={onClose}>
        <img src={closeModalIcon} alt="close modal button" />
      </button>
      <h2>🎉 Spread the Word, Earn More 💰</h2>
      <p>
        Every time someone uses your referral link to make a purchase during an{" "}
        <b>IDO</b>, you get <b>up to 1%</b> from their purchase — calculated
        automatically and embedded in the smart contract, paid to you after each
        transaction.*
      </p>
      <p>+20% from your referrals Karma (if they complete at least 1 quest)</p>
      <p style={{ fontSize: 12, opacity: 0.7 }}>
        * The commission rate may change.
      </p>
      <Button
        variant="pink"
        onClick={handleCopyLink}
        className={styles.copyButton}
      >
        {isCopied ? (
          <div className={styles.copied}>
            Copied <FaCheck />
          </div>
        ) : (
          "Copy Link"
        )}
      </Button>
    </Modal>
  );
};

export default ReferralModal;
